import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./css/App.css";
import ScrollToTop from "./frontend/components/ScrollToTop";
import Navbar from "./frontend/designSystem/Navbar";
import Footer from "./frontend/designSystem/Footer";
import PrivacyPage from "./frontend/pages/PrivacyPolicyPage";
import ParentsPage from "./frontend/pages/ParentsPage";
import SchoolPage from "./frontend/pages/SchoolPage";
import ContactUs from "./frontend/components/ContactUs";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<ParentsPage />} />
          <Route path="/*" element={<ParentsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/for-schools" element={<SchoolPage />} />
          {/* <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} /> */}
        </Routes>
       
        <Footer />
      </div>
    </Router>
  );
}

export default App;
